import classnames from 'classnames';

import type { AppState } from 'bootstrap.store';
import { useAppSelector } from 'utils/redux/useAppSelector';

import MessageSection from '../containers/messageSection';
import ReplySection from '../containers/replySection';

export const ConversationMessages = (): JSX.Element => {
  const { isFocusMode, requester } = useAppSelector((state: AppState) => ({
    isFocusMode: state.conversation.isFocusMode,
    requester: state.conversation.metaConversation.requester,
  }));

  return (
    <div
      className={classnames('content message-content scrollable', {
        'focus-mode': isFocusMode,
      })}
      style={{ padding: 0 }}
    >
      <MessageSection />

      {!requester?.anonymized_at && <ReplySection />}
    </div>
  );
};
